import { Injectable, signal } from "@angular/core";
import { OrderWizardDto } from "../../features/pages/order/model/order-wizard.model";
import { HttpClient } from "@angular/common/http";
import { SessionUpdateRequest } from "./session-update-request.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SessionService {
    constructor(
        private _httpClient: HttpClient
    ) { }
    
    Update(updateRequest: SessionUpdateRequest) : Observable<SessionUpdateRequest> {
        // console.warn("Session Update Request", updateRequest);
        return this._httpClient
            .post<SessionUpdateRequest>(`api/session/update`, updateRequest, { withCredentials: true });
    }
    public state = new SessionState();
}

@Injectable({ providedIn: 'root' })
export class SessionState {
    private readonly _orderWizard = signal<OrderWizardDto | null>(null);
}